import React, { useEffect, useRef, useState } from 'react';
import DateRangePicker from './DateRangePicker';
import { formatDateUser } from '../../utils/dateUtils';

const getCurrentFiscalYearRange = () => {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const fyStartMonth = 3; // April (0-indexed)
  const fyStartYear = now.getMonth() >= fyStartMonth ? now.getFullYear() : now.getFullYear() - 1;
  const start = new Date(fyStartYear, fyStartMonth, 1, 0, 0, 0, 0);
  const end = new Date(fyStartYear + 1, 2, 31, 23, 59, 59, 999);
  return { start, end };
};

const HeaderDateFilters = ({ value, onChange }) => {
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const pickerRef = useRef(null);
  const hasAppliedDefaultRef = useRef(false);

  useEffect(() => {
    if (hasAppliedDefaultRef.current) return;

    const hasRange = Boolean(value?.startDate && value?.endDate);
    if (hasRange) {
      hasAppliedDefaultRef.current = true;
      return;
    }

    const { start, end } = getCurrentFiscalYearRange();
    hasAppliedDefaultRef.current = true;
    onChange({
      startDate: start.toISOString(),
      endDate: end.toISOString(),
      label: 'Current FY'
    });
  }, [value, onChange]);

  useEffect(() => {
    if (!isPickerOpen) return;
    const handleClick = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setIsPickerOpen(false);
      }
    };
    const handleKey = (event) => {
      if (event.key === 'Escape') {
        setIsPickerOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClick);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('keydown', handleKey);
    };
  }, [isPickerOpen]);

  const handleToggle = (event) => {
    event.stopPropagation();
    setIsPickerOpen((prev) => !prev);
  };

  const handleRangeChange = (range) => {
    setIsPickerOpen(false);
    onChange(range);
  };

  const handleClear = () => {
    onChange('all');
    setIsPickerOpen(false);
  };

  const isRangeSelected = Boolean(value?.startDate && value?.endDate);

  return (
    <div className="header-date-filters">
      <div className="date-range-fields">
        <button
          className="drp-input"
          onClick={handleToggle}
          aria-label="Select start date"
        >
          {value?.startDate ? formatDateUser(value.startDate) : 'Start date'}
        </button>
        <span className="date-separator">-</span>
        <button
          className="drp-input"
          onClick={handleToggle}
          aria-label="Select end date"
        >
          {value?.endDate ? formatDateUser(value.endDate) : 'End date'}
        </button>
        {isRangeSelected && (
          <button
            className="drp-clear btn"
            onClick={handleClear}
            aria-label="Clear date range"
          >
            Clear
          </button>
        )}
      </div>

      {isPickerOpen && (
        <div className="header-date-picker" ref={pickerRef}>
          <DateRangePicker value={value} onChange={handleRangeChange} />
        </div>
      )}
    </div>
  );
};

export default HeaderDateFilters;
